import { toNumberOrUndefined } from 'commerce-products-lib/utils/toNumber';
export const isBundleItemsCardItem = item => {
  return typeof item.properties.amount.value === 'string' && typeof toNumberOrUndefined(item.properties.amount.value) === 'number' && typeof item.properties.quantity.value === 'string' && typeof toNumberOrUndefined(item.properties.quantity.value) === 'number' && typeof item.properties.name.value === 'string';
};
export function assertIsBundleItemsCardItem(item) {
  if (!isBundleItemsCardItem(item)) {
    throw new Error(`Item with objectId ${item.objectId} is not a valid BundleItemsCardItem`);
  }
}